export default __webpack_public_path__ + "static/media/Logo.0a1f0582.svg";